
(function(template){
  define('vue!optionalClassProgram/components/classComponents/mandatoryComponents/mandatoryClassComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment",
    "vue!../classDescriptionComponent",
    "vue!./innerComponent",

  ], function (
    Vue,
    helpers,
    vuex,
    moment,
    classDescriptionComponent,
    innerComponent
  ) {
    return {
      template: template,
      name: "mandatoryClasses",
      props: ['customerID'],
      data: function () {
        return {

        }
      },
      computed: _.extend(
        vuex.mapState(['users']), {
          mandatoryClasses: function(){
           return this.groupClasses("N",this.customerID)
          }

        }),
      components: {
        'classDescriptionComponent':classDescriptionComponent,
        'innerComponent': innerComponent
      },
    }
  })
})('<div class="mandatory-class-component"> <div class="accordion" id="accordion1"> <div class="accordion-group" v-for="(value, propertyName, mIndex) in mandatoryClasses" :key="mIndex"> <div class="accordion-heading" v-if="propertyName != \'N\'"> <a aria-expanded="false" :aria-controls="\'m\'+customerID+mIndex" class="accordion-toggle" data-toggle="collapse" data-parent="#accordion1" :data-target="\'#m\'+customerID+mIndex"> <span class="optionalclass-accordion-header-text"> {{propertyName.split(\'|\')[0]}}</span> </a> </div> <div :id="\'m\'+customerID+mIndex" role="region" aria-label="{{propertyName.split(\'|\')[0]}}" class="accordion-body collapse " :class="propertyName == \'N\'? \'in\': \'\'"> <div v-for="(item, classindex) in value" :key="classindex" :class="propertyName != \'N\'?\'optionalclass-accordion-body-text-parent\':\'optionalclass-noCascade\'"> <!-- <span class="mandatoryclass-accordion-body-text"> <strong>{{item.SpaItemName}}</strong>_{{item.eventDate}}_{{item.eventStartTime}}_{{item.eventEndTime}}</span> --> <innerComponent v-bind:cascadeOption="propertyName" v-bind:item="item" v-bind:customerID="customerID"></innerComponent> </div> </div> </div> </div> </div>');
